<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Editar Consultor Cliente</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="mt-4 mb-2">
    @if (!loadingScreen) {
      <mat-card class="card-style">
        <h3 class="px-6">Consultor</h3>
        <div [formGroup]="form" class="pt-0 pb-2 px-6 mb-3">
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field
              class="input-tg mt-message-input w-4/12"
              appearance="outline"
            >
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>

            <mat-form-field
              class="input-tg mt-message-input w-4/12"
              appearance="outline"
            >
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" type="email" />
            </mat-form-field>

            <mat-form-field
              class="input-tg mt-message-input w-2/12"
              appearance="outline"
              [floatLabel]="
                this.form.get('phone')?.value &&
                this.form.get('phone')!.value.length > 0
                  ? 'always'
                  : 'auto'
              "
            >
              <mat-label>Telefone</mat-label>
              <input
                matInput
                formControlName="phone"
                [mask]="'(99) 99999-9999'"
              />
            </mat-form-field>

            <mat-form-field
              class="input-tg mt-message-input w-2/12"
              appearance="outline"
            >
              <mat-label>Data nascimento</mat-label>
              <input
                matInput
                [matDatepicker]="birth"
                (focus)="openDatepicker()"
                formControlName="birth"
                [max]="maxDate"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="birth"
              ></mat-datepicker-toggle>
              <mat-datepicker #birth></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="flex justify-end items-center">
            <button
              mat-flat-button
              class="btn-tg w-1/12"
              [disabled]="form.invalid || loadingBtn"
              (click)="editConsultant()"
            >
              @if (loadingBtn) {
                <mat-spinner
                  diameter="22"
                  class="loading-spinner"
                  selected-track-color="red"
                ></mat-spinner>
              } @else {
                Salvar
              }
            </button>
          </div>
        </div>
      </mat-card>
      <mat-card class="card-style mt-6">
        <h3 class="px-6">Clientes</h3>
        <mat-tab-group animationDuration="400ms">
          <mat-tab label="Associados">
            <div class="py-2 px-6 mb-3">
              @if (true) {
                <form-client-search
                  [search]="inputSearchClient"
                  [listSearch]="listSearch"
                  (responseSearch)="search($event, 'TClient')"
                />
              }
              @if (!loadingClient) {
                @if (totalClient > 0) {
                  <div>
                    <table-list-consultant
                      [dataSource]="listClient"
                      [columns]="columnsClient"
                      [loading]="loadingBIcon"
                      (addItemEvent)="addItem($event)"
                      (removeItemEvent)="removeItem($event)"
                    />
                  </div>
                } @else {
                  <div>
                    <h3 class="text-center">Nenhum cliente associado.</h3>
                  </div>
                }
              } @else {
                <div>
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
              }
              <div [hidden]="loadingClient || totalClient == 0">
                <mat-paginator
                  #paginatorClient
                  [length]="totalClient"
                  [pageSizeOptions]="[1, 5, 10, 20, 50]"
                  [pageSize]="rowsClient"
                  [pageIndex]="pageClient - 1"
                  (page)="pageChanged($event, 'TClient')"
                >
                </mat-paginator>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Não associados">
            <div class="py-2 px-6 mb-3">
              @if (true) {
                <form-client-search
                  [search]="inputSearchNotClient"
                  [listSearch]="listSearch"
                  (responseSearch)="search($event, 'TNClient')"
                />
              }
              @if (!loadingNotClient) {
                @if (totalNotClient > 0) {
                  <div>
                    <table-list-consultant
                      [dataSource]="listNotClient"
                      [columns]="columnsNotClient"
                      [loading]="loadingBIcon"
                      (addItemEvent)="addItem($event)"
                      (removeItemEvent)="removeItem($event)"
                    />
                  </div>
                } @else {
                  <div>
                    <h3 class="text-center">Nenhum cliente.</h3>
                  </div>
                }
              } @else {
                <div>
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
              }
              <div [hidden]="loadingNotClient || totalNotClient == 0">
                <mat-paginator
                  #paginatorNotClient
                  [length]="totalNotClient"
                  [pageSizeOptions]="[1, 5, 10, 20, 50]"
                  [pageSize]="rowsNotClient"
                  [pageIndex]="pageNotClient - 1"
                  (page)="pageChanged($event, 'TNClient')"
                >
                </mat-paginator>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card>
    } @else {
      <div class="m-auto">
        <mat-spinner mode="indeterminate"></mat-spinner>
      </div>
    }
  </div>
</mat-card>
